<template>
    <div>
        <div class="col-xs-3" style="height: 100%; padding:0" v-show="!loading && requestFinished && hasData">
            <dashboard-item-menu
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="malwareSoftwareEfficienyMenuList"
                @menuItemClicked="onMalwareFileSelect"></dashboard-item-menu>
        </div>
        <div ref="chronometerContainer" class="col-xs-9" style="height: 100%;" v-show="selectedMalwareFile">
            <chronometer v-if="selectedMalwareFile"
                         ref="chronometer"
                         :textColor="chronometerProgressColor"
                         :circleColor="chronometerProgressColor"
                         :backgroundCircleColor="chronometerRemainingProgressColor"
                         :progress="selectedMalwareFile.progress"
                         :text="selectedMalwareFile.time"></chronometer>
        </div>
        <div class="malware-file-status-text" :style="{'color': chronometerProgressColor}" v-if="selectedMalwareFile">
            <div style="width: 100%; height: 100%; position: relative">
                <svg viewBox="0 0 545 455" preserveAspectRatio="xMidYMid meet" ref="text-svg"
                     style="width:100%; height:100%;">
                    <text class="center-text" x="46%" y="10%" text-anchor="middle" fill="white">Hour 0 Prevention</text>
                    <text class="center-text" x="0" y="90%" :fill="chronometerProgressColor">
                        {{selectedMalwareFile.vendor ? selectedMalwareFile.vendor : 'Your AEP Vendor'}}
                    </text>
                    <text class="center-text" x="0" y="95%" :fill="chronometerProgressColor">{{malwareFileStatusText}}
                    </text>
                    <!--<text class="center-text" x="84%" y="93%" fill="white" style="font-size: 20px; cursor: pointer; " @click="onVTClick">VT</text>-->
                    <!--<image xlink:href="../../../assets/valkyrie_logo_head.png" x="90%" y="86.5%" height="40px" width="40px" @click="onValkyrieClick" style="cursor: pointer;"/>-->
                    <!--<image xlink:href="../../../assets/download.svg" x="74%" y="85.5%" height="50px" width="50px" @click="onDownloadPcapClick" style="cursor: pointer;"/>-->
                </svg>
            </div>
        </div>
        <ul id="menu" class="mfb-component--br mfb-zoomin" data-mfb-toggle="hover" v-if="selectedMalwareFile">
            <li class="mfb-component__wrap">
                <a href="#" class="mfb-component__button--main">
                    <img class="menu-icon" src="../../../assets/show-more.png" width="20px"/>
                </a>
                <ul class="mfb-component__list">
                    <li>
                        <a @click="onVTClick" data-mfb-label="Virus Total" class="mfb-component__button--child"
                           style="text-decoration: none;">
                            <div
                                style="font-size: 20px; color: white; text-align: center; height: 100%; line-height: 50px;">
                                VT
                            </div>
                        </a>
                    </li>
                    <li>
                        <a @click="onValkyrieClick" data-mfb-label="Valkyrie Verdict"
                           class="mfb-component__button--child">
                            <img class="menu-icon" src="../../../assets/valkyrie_logo_head.png" width="20px"/>
                        </a>
                    </li>
                    <li>
                        <a @click="onDownloadPcapClick" data-mfb-label="Kill-Chain Report"
                           class="mfb-component__button--child">
                            <img class="menu-icon" src="../../../assets/radar.png" width="20px"/>
                        </a>
                    </li>
                    <li>
                        <a @click="onDownloadUnverdictedFiles" data-mfb-label="Download Not Verdicted Files"
                           class="mfb-component__button--child">
                            <img class="menu-icon" src="../../../assets/download-button.png" width="20px"/>
                        </a>
                    </li>
                    <!--<li>-->
                    <!--<a @click="onValkyrieClick" data-mfb-label="Export All" class="mfb-component__button&#45;&#45;child">-->
                    <!--<img class="menu-icon" src="../../../assets/download-button.png" width="20px"/>-->
                    <!--</a>-->
                    <!--</li>-->
                </ul>
            </li>
        </ul>
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'aqua'"></loading-modal>
        <div class="no-data-container" v-if="requestFinished && !hasData">
            <p>There is no malware file to display</p>
            <p v-if="!hasVendor">Make sure you have selected your security vendor from settings</p>
        </div>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Chronometer from '@/components/chronometer/Chronometer.vue'
    import Constants from '@/utils/constants'
    import Common from '@/utils/Common.vue'
    import LoadingModal from "@/components/modals/LoadingModal";

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "rgb(0,237,251)";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_ITEM_BACKGROUND_COLOR = "rgb(0,178,188)";
    const MENU_TITLE_COLOR = "white"

    const CHRONOMETER_NOT_DETECTED_COLOR = "rgb(255,0,75)";
    const CHRONOMETER_DETECTED_COLOR = "rgb(0,237,251)";
    const CHRONOMETER_REMANINING_PROGRESS_COLOR = "rgb(30,50,61)";

    const TWO_DAYS_SECONDS = 48 * 60 * 60;

    export default {
        name: 'malware-software-efficiency',
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        components: {
            DashboardItemMenu: DashboardItemMenu,
            Chronometer: Chronometer,
            LoadingModal: LoadingModal
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'HOUR\nZERO\nPREVENTION\nTECHNOLOGY',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,

                selectedMalwareFile: null,
                malwareSoftwareEfficienyMenuList: [],

                vendorId: 0,
                malwareFiles: [],
                timer: null,
                fatTimer: null,

                loading: false,
                requestFinished: false,
                isMenuSorted: false,
                pageName: "Malware Software Efficiency"
            }
        },
        methods: {
            createMalwareSoftwareEfficienyMenuItem(malwareFile) {
                return {
                    id: malwareFile.sha1,
                    text: malwareFile.filename ? malwareFile.filename : malwareFile.sha1,
                    color: MENU_ITEM_COLOR,
                    progress: malwareFile.progress,
                    progressColor: malwareFile.is_detected ? CHRONOMETER_DETECTED_COLOR : CHRONOMETER_NOT_DETECTED_COLOR,
                    selectedColor: "white",
                    selected: this.selectedMalwareFile == malwareFile,
                    isDetected: malwareFile.is_detected,
                    malwareFile: malwareFile
                };
            },
            createMalwareSoftwareEfficiencyMenuList() {
                var items = [];
                for (let i = 0; i < this.malwareFiles.length; i++) {
                    let file = this.malwareFiles[i];
                    items.push(this.createMalwareSoftwareEfficienyMenuItem(file));
                }
                this.malwareSoftwareEfficienyMenuList = [
                    {
                        type: "selectableProgress",
                        text: "AFFECTED FILES",
                        color: MENU_TITLE_COLOR,
                        backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                        open: true,
                        items: items
                    }
                ];
            },
            getMalwareFiles() {
                let log_start = Date.now();
                this.loading = true;
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/malware/list';
                this.$http.get(path)
                    .then(response => {
                        this.malwareFiles = response.data.data;
                        this.vendorId = response.data.vendor_id;
                        if (this.hasData) {
                            this.calculateProgressAndTimeForAllFiles();
                            this.selectedMalwareFile = this.malwareFiles[0];
                            this.createMalwareSoftwareEfficiencyMenuList();
                            this.startTimer();
                        }

                        this.requestFinished = true;
                        this.$emit('loaded', 'malware-software-efficiency', this.getDurationInSeconds(log_start, Date.now()));
                        this.loading = false;
                    }, response => {
                        this.requestFinished = true;
                        this.loading = false;
                    });
            },
            calculateProgress(begin, end) {
                var seconds = this.getTimePassedInSeconds(begin, end);
                return ((100 * seconds) / TWO_DAYS_SECONDS);
            },
            calculateProgressAndTimeForAllFiles() {
                var files = [];
                for (let i = 0; i < this.malwareFiles.length; i++) {
                    let file = this.malwareFiles[i];

                    let progress = this.calculateProgress(file.valkyrie_detect_time, file.detection_time);
                    let time = this.getTimePassedInHoursAndMinutesAndSeconds(file.valkyrie_detect_time, file.detection_time);

                    if (progress >= 100) {
                        file.progress = 100;
                        file.time = "48 : 00 : 00";
                    }
                    else {
                        file.progress = progress;
                        file.time = this.getTwoDigitValue(time.hours) + " : " + this.getTwoDigitValue(time.minutes) + " : " + this.getTwoDigitValue(time.seconds);
                    }
                    files.push(file);
                }
                if (!this.isMenuSorted) {
                    this.malwareFiles = this.sortyByKey("progress", files);
                    this.isMenuSorted = true;
                } else {
                    this.malwareFiles = files;
                }
            },
            startTimer() {
                var self = this;
                this.timer = setInterval(function () {
                    self.calculateProgressAndTimeForAllFiles();
                }, 1000);
                this.fatTimer = setInterval(function () {
                    self.createMalwareSoftwareEfficiencyMenuList();
                    self.$refs.chronometer.update();
                }, 10000);
            },
            onMalwareFileSelect(item) {
                this.selectedMalwareFile = null;
                this.$nextTick(function () {
                    this.selectedMalwareFile = item.malwareFile;
                });
            },
            onEnlargeClick() {
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            onVTClick() {
                this.openInNewTab(this.selectedMalwareFile.vt_permalink);
            },
            onValkyrieClick() {
                this.verdictSearchHandlerCommon(this.selectedMalwareFile.sha1, this, this.pageName, false);
            },
            onDownloadPcapClick() {
                let openUrl = this.getPlatformKillChainEndPoint + "/" + this.selectedMalwareFile.sha1 + "/summary";
                this.openUrlInIframe(openUrl, Constants.IframeSelections.Killchain);
            },
            onDownloadUnverdictedFiles() {
                let undetectedFiles = this.malwareFiles
                    .map(function (file) {
                            var verdicted = '';
                            if(file.is_detected == true){
                                verdicted = 'Verdicted';
                            }else{
                                verdicted = 'Not Verdicted';
                            }
                            return {
                                sha1: file.sha1 ? file.sha1 : '',
                                filename: file.filename ? file.filename : '',
                                verdicted: verdicted
                            }
                        }
                    );

                let args = {
                    filename: 'hour-zero-protection-undetected-files.csv'
                };

                this.downloadCSV(undetectedFiles, args);
            },
            ...
                mapActions([
                    "setDashboardEnlargedItem"
                ])
        },
        computed: {
            malwareFileStatusText() {
                if (this.selectedMalwareFile && this.selectedMalwareFile.is_detected) {
                    var time = this.getTimePassedInHoursAndMinutesAndSeconds(this.selectedMalwareFile.valkyrie_detect_time, this.selectedMalwareFile.detection_time);
                    return "verdicted this malware in " + time.hours + "h " + time.minutes + "min";
                } else {
                    return "still hasn't verdicted this malware";
                }
            },
            chronometerProgressColor() {
                if (this.selectedMalwareFile && this.selectedMalwareFile.is_detected)
                    return CHRONOMETER_DETECTED_COLOR;
                else
                    return CHRONOMETER_NOT_DETECTED_COLOR;
            }
            ,
            chronometerRemainingProgressColor() {
                return CHRONOMETER_REMANINING_PROGRESS_COLOR;
            }
            ,
            hasData() {
                return this.malwareFiles && this.malwareFiles.length > 0;
            },
            hasVendor() {
                return this.vendorId > 0;
            },
            ...mapGetters([
                "getPlatformKillChainEndPoint"
            ])
        }
        ,
        mounted() {
            this.getMalwareFiles();
        }
        ,
        beforeDestroy() {
            clearInterval(this.timer);
            clearInterval(this.fatTimer);
        }
    }
</script>

<style scoped>

    .malware-file-status-text {
        width: 70%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 30%;
        font-size: 16px;
        font-family: 'Digital-Serial-Bold';
        z-index: 5;
    }

    .center-text {
        font-size: 14px;
    }

    .no-data-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 75%;
        height: 25%;
        margin: auto;
        color: white;
        font-family: 'Digital-Serial-Bold';
        text-align: center;
        font-size: 20px;
    }

    #menu {
        position: absolute;
        right: 1%;
        bottom: 7%;
        margin: 10px;
    }

    .menu-icon {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        margin: auto;
    }

    .mfb-component__button--main, .mfb-component__button--child {
        width: 50px;
        height: 50px;
        background-color: rgb(0, 178, 188);
    }

    .mfb-component__button--main {
        background-color: transparent;
        border: 3px solid white;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/malware-software-efficiency/MalwareSoftwareEfficiency.vue